import React, { useEffect, useState } from "react";
import "./Resources.scss";
import PrimaryButton from "../../common/primaryButton";
import { Link, useNavigate } from "react-router-dom";
import { getArticles } from "../../services/blogs";
import { config } from "../../config";
import moment from "moment";
import { featureVideo } from "../../assets/videos/videos";

const Resources = ({ homePage, style }) => {
  const navigate = useNavigate();
  const NavigateToBlogs = () => {
    navigate("/blogs");
  };
  const [getBlogs, setGetBlogs] = useState([]);
  const [recentItem, setRecentItem] = useState();
  const [currentPage] = useState(1);

  useEffect(() => {
    GetArticleListing(currentPage);
  }, [currentPage]);

  const GetArticleListing = async () => {
    const { status, res } = await getArticles(1, 4);
    if (status) {
      setRecentItem(
        res.data[0].attributes?.medical_category?.data?.attributes?.name
      );
      setGetBlogs(res.data);
    }
  };

  return (
    <section
      style={style}
      className={`section resources-section ${homePage ? "" : "tech-page"}`}
    >
      <div className="container-fluid">
        <div className="content">
          {homePage ? (
            <h2 data-aos="fade-up" data-aos-delay="400">
              Insights, innovations shaping the future of precision health
            </h2>
          ) : (
            ""
          )}
          <div className="featured">
            <div className="text" data-aos="fade-right" data-aos-delay="400">
              <h4>Featured</h4>
              <p>This week</p>
            </div>
            <div className="img" data-aos="fade-left" data-aos-delay="400">
              <video autoPlay muted loop playsInline>
                <source src={featureVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div className="video-text">
                <div className="tag">
                  <span>Technology</span>
                </div>
                <h3>
                  Gattaca expands clinical trial with clinic participation
                  worldwide...
                </h3>
                <p>7min. — July 7, 2023</p>
              </div>
            </div>
          </div>
          <div className="resources">
            <div className="heading">
              <div data-aos="fade-right" data-aos-delay="400">
                <span>Resources</span>
                <h3>
                  Read our expert's articles to help you learn about health,
                  genetics and more!
                </h3>
              </div>
              <PrimaryButton
                primaryBtnText="Gattaca Blogs"
                handleClick={NavigateToBlogs}
                className="dark"
                aos="fade-left"
                aosDelay="400"
              />
            </div>
            <div className="cards">
              {getBlogs.map((item, index) => (
                <Link
                  data-aos="fade-up"
                  data-aos-delay={`${index * 200}`}
                  to={`/blog-detail/${item?.id}`}
                  onClick=""
                  key={item?.id}
                >
                  <div className="card">
                    <svg
                      width="41"
                      height="41"
                      viewBox="0 0 41 41"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M34.4232 34.3885C32.8699 35.9418 31.1532 37.186 29.2732 38.121C27.4266 39.0421 25.448 39.6704 23.4082 39.9835C19.3303 40.6155 15.1568 39.9647 11.4649 38.121C9.5849 37.186 7.86824 35.9418 6.3149 34.3876C4.76074 32.8343 3.51907 31.1218 2.58907 29.2468C0.738401 25.5536 0.0847605 21.3754 0.71907 17.2935C1.03206 15.2535 1.6604 13.2745 2.58157 11.4276C3.51657 9.54847 4.76074 7.8318 6.3149 6.27764C7.86824 4.7243 9.58157 3.48264 11.4566 2.55264C13.3025 1.62843 15.2822 0.999933 17.3232 0.690137C19.3532 0.37347 21.3841 0.37347 23.4149 0.690137C25.4559 0.999946 27.4356 1.62844 29.2816 2.55264C31.1566 3.48264 32.8699 4.7243 34.4232 6.27764C35.9766 7.8318 37.2216 9.54847 38.1566 11.4276C39.0768 13.2717 39.7027 15.2484 40.0116 17.286C40.3282 19.3045 40.3282 21.36 40.0116 23.3785C39.7018 25.4195 39.0733 27.3992 38.1491 29.2451C37.2191 31.1201 35.9766 32.8335 34.4241 34.3868L34.4232 34.3885ZM26.1774 25.906L27.8941 25.8985V12.8093H14.8024L14.7957 14.526L24.9566 14.5185L12.2457 27.2301L13.4732 28.4576L26.1841 15.7468L26.1757 25.9076L26.1774 25.906Z"
                        fill="#121316"
                      />
                    </svg>
                    <div className="img">
                      <img
                        src={`${config.imgBaseUrl}${item?.attributes?.display_image?.data?.attributes?.url}`}
                        alt="img"
                      />
                    </div>
                    <div className="card-content">
                      <h4>{item?.attributes?.title}</h4>
                      <PrimaryButton
                        primaryBtnText="Read Article"
                        noIcon
                        className="dark"
                      />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resources;
